import { ExternalGamesType } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'

export const loadExternalGamesPeriodInMilliseconds: number = 1 * 1000 * 60 * 60

export const externalGamesFolderByExternalGameType: Record<ExternalGamesType, string> = {
  top: 'top-games.json',
  new: 'new-games.json',
  categories: 'categories.json',
}
